import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import { ACESFilmicToneMapping } from 'three'
import { Environment } from '@react-three/drei'
import { config } from '../config'
import { Lighting } from './Lighting'
import { Background } from './Background'
import { CameraRig } from './CameraRig'
import { Cube } from './Cube'
import { FilmRing } from './FilmRing'
import { DropBox } from './DropBox'
import { KeyboardBindings } from '../input/KeyboardBindings'
import { CameraDriver } from '../tracking/CameraDriver'
import { Vignette } from '../ui/Vignette'

export function SceneRoot() {
  return (
    <>
      <Canvas
        camera={{
          fov: config.scene.cameraFov,
          near: config.scene.cameraNear,
          far: config.scene.cameraFar,
          position: config.scene.cameraPosition,
        }}
        gl={{
          antialias: true,
          alpha: false,
          powerPreference: 'high-performance',
        }}
        onCreated={({ gl }) => {
          gl.toneMapping = ACESFilmicToneMapping
          gl.toneMappingExposure = 1.0
          gl.setClearColor(config.scene.backgroundColor)
        }}
        dpr={[1, 2]}
      >
        <Suspense fallback={null}>
          <Background />
          <Lighting />
          <Suspense fallback={null}>
            <Environment preset="city" background={false} environmentIntensity={0.45} />
          </Suspense>
          <CameraRig />
          <FilmRing />
          <DropBox />
          <Cube />
        </Suspense>
      </Canvas>
      <KeyboardBindings />
      <CameraDriver />
      <Vignette />
    </>
  )
}
